import React, { useEffect } from "react";
import { Switch, Form, Button, Flex, Input } from "antd";
import { Col, Row } from "antd";

import { productType } from "../../../types/product";
import { useIntl } from "react-intl";

interface InfoProps {
  onNextStep: () => void;
  onClose: () => void;
  product: productType;
  setProduct: React.Dispatch<React.SetStateAction<productType>>;
}

function TeamMember({ onNextStep, onClose, product, setProduct }: InfoProps) {
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    setProduct({
      ...product,
      enable_retail_sales: values?.enable_retail_sales,
      enable_team_member_commission: values?.enable_team_member_commission,
      markup: values?.markup,
      quick_add_reservation: values?.quick_add_reservation,
      retail_price: values?.retail_price,
      supply_price: values?.supply_price,
    });
    onNextStep();
  };

  const supplyPrice = Number(Form.useWatch("supply_price", form)) || 0;
  const retailPrice = Number(Form.useWatch("retail_price", form)) || 0;
  const intl = useIntl();
  useEffect(() => {
    const calculateMarkup = () => {
      let calculatedMarkup = 0;

      if (
        supplyPrice !== undefined &&
        retailPrice !== undefined &&
        supplyPrice !== 0
      ) {
        calculatedMarkup = ((retailPrice - supplyPrice) / supplyPrice) * 100;
      }

      form.setFieldsValue({ markup: calculatedMarkup.toFixed(2) });
    };

    calculateMarkup();
    // handelCheckAllPrice();
  }, [form, supplyPrice, retailPrice]);

  // const handelCheckAllPrice = () => {

  // }

  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      form={form}
      onValuesChange={(changedValues: Partial<productType>, values: any) => {
        setProduct({ ...product, ...changedValues });
      }}
      initialValues={{
        enable_team_member_commission:
          product?.enable_team_member_commission || false,
        enable_retail_sales: product?.enable_retail_sales || false,
        quick_add_reservation: product?.quick_add_reservation || false,
        supply_price: +product?.supply_price,
        retail_price: +product?.retail_price,
        markup: product?.markup,
      }}
    >
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 8 }}
        className="p-2 rounded bg-color-light-gr w-full text-color-primary mb-5"
      >
        <Col xl={24} lg={12} xs={24} sm={12} className="my-4 text-lg">
          {intl.formatMessage({ id: "pricing" })}
        </Col>
        <Col className="gutter-row" xl={8} lg={8} xs={24} sm={24}>
          <Form.Item
            name="supply_price"
            label={intl.formatMessage({ id: "supply_price_label" })}
            required={false}
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: "supply_price_required_message",
                }),
              },
              {
                validator(rule, value, callback) {
                  if (value <= 0) {
                    return Promise.reject(
                      intl.formatMessage({
                        id: "supply_price_validation_message",
                      })
                    );
                  } else {
                    return Promise.resolve();
                  }
                },
              },
            ]}
          >
            <Input
              type="number"
              min={1}
              placeholder={intl.formatMessage({
                id: "supply_price_placeholder",
              })}
            />
          </Form.Item>
        </Col>

        <Col className="gutter-row" xl={8} lg={8} xs={24} sm={12}>
          <Form.Item
            label={intl.formatMessage({ id: "retail_price_label" })}
            required={false}
            name="retail_price"
            dependencies={["supply_price"]}
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: "retail_price_required_message",
                }),
              },
              {
                validator(rule, value, callback) {
                  if (value <= 0) {
                    return Promise.reject(
                      intl.formatMessage({
                        id: "retail_price_validation_message",
                      })
                    );
                  } else if (+value < +form.getFieldValue("supply_price")) {
                    return Promise.reject(
                      intl.formatMessage({
                        id: "retail_price_greater_than_supply_message",
                      })
                    );
                  } else {
                    return Promise.resolve();
                  }
                },
              },
            ]}
          >
            <Input
              placeholder={intl.formatMessage({
                id: "retail_price_placeholder",
              })}
              className="w-full my-input"
              type="number"
              min={1}
            />
          </Form.Item>
        </Col>
        <Col className="gutter-row" xl={8} lg={8} xs={24} sm={12}>
          <Form.Item
            required={false}
            label={intl.formatMessage({ id: "profit_margin_label" })}
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: "profit_margin_required_message",
                }),
              },
            ]}
            name="markup"
            initialValue={0}
          >
            <Input
              placeholder="..."
              className="w-full my-input"
              suffix={"%"}
              type="number"
              readOnly
              min={1}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col className="gutter-row" xl={19} lg={12} xs={24} sm={8} span={11}>
          <label className="text-base  mt-3 w-full">
            {intl.formatMessage({ id: "commission_label" })}
          </label>
        </Col>
        <Col className="gutter-row" xl={5} lg={12} xs={24} sm={8} span={11}>
          <Form.Item
            name="enable_team_member_commission"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col className="gutter-row" xl={19} lg={12} xs={24} sm={8} span={11}>
          <label className="text-base  mt-3 w-full">
            {intl.formatMessage({ id: "enable_retail_sales_label" })}
          </label>
        </Col>
        <Col className="gutter-row" xl={5} lg={12} xs={24} sm={8} span={11}>
          <Form.Item name="enable_retail_sales" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col className="gutter-row" xl={19} lg={12} xs={24} sm={8} span={11}>
          <label className="text-base  mt-3 w-full">
            {intl.formatMessage({ id: "quick_add_reservation_label" })}
          </label>
        </Col>
        <Col className="gutter-row" xl={5} lg={12} xs={24} sm={8} span={11}>
          <Form.Item name="quick_add_reservation" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Col>
      </Row>

      <Flex gap="middle" align="center" justify="center">
        <Button type="primary" block htmlType="submit">
          {intl.formatMessage({ id: "continue_button_label" })}
        </Button>
        <Button
          type="primary"
          onClick={onClose}
          className="btn-primary-light"
          block
          htmlType="button"
        >
          {intl.formatMessage({ id: "cancel_button_label" })}
        </Button>
      </Flex>
    </Form>
  );
}

export default TeamMember;
